<template>
  <div v-if="activeVenue && campaigns && events">
    <popup-select-event-type ref="popupSelectEventType" v-on:onSelected="onSelectedEventType" />
    <popup-add-event ref="popupAddEvent" />
    <popup-add-so-me ref="popupAddSoMe" />
    <popup-add-from-template ref="popupAddFromTemplate" />
    <vs-row vs-type="flex" vs-justify="space-between" class="mb-5 pb-2">
      <vs-col vs-justify="center" vs-type="flex" vs-align="center" vs-w="12">
        <vs-button radius color="primary" icon="chevron_left" @click="handlePrevMonth"></vs-button>
        <span class="mx-5" style="min-width: 200px; text-align: center"
          ><h3>{{ calendarTitle }}</h3></span
        >
        <vs-button radius color="primary" icon="chevron_right" @click="handleNextMonth"></vs-button>
      </vs-col>
    </vs-row>

    <popup-add-campaign ref="popupAddCampaign" />

    <vs-row v-if="activeVenue" vs-justify="center">
      <vs-col vs-justify="center" vs-align="center" vs-w="5" class="pr-5">
        <vs-card>
          <div slot="header">
            <h3>{{ currentCampaigns.length }} Campaigns</h3>
          </div>
          <div style="max-height: 300px; overflow-y: scroll">
            <vs-list>
              <vs-list-item
                class="campaign-item py-2"
                v-for="campaign in currentCampaigns"
                :key="campaign.id"
                :icon="campaign.starred ? 'star' : null"
                :subtitle="campaign.description"
                @click.native="() => handleClickCampaign(campaign)"
              >
                <template slot="avatar">
                  <vs-chip
                    class="campaign-button mr-5 py-1 px-3 my-0"
                    style="min-width: 160px; max-width: 160px"
                    :style="{
                      color: campaign.color == '#111111' ? 'white' : 'black',
                    }"
                    :color="campaign.color"
                    >{{ campaign.isHQ ? "(HQ) " + campaign.title : campaign.title }}</vs-chip
                  >
                </template>
              </vs-list-item>
            </vs-list>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                color="grey"
                icon="add"
                @click="$refs.popupAddCampaign.show(calendarYear, calendarMonthNumber)"
              ></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="3" class="px-5">
        <vs-card>
          <div slot="header">
            <h3>Budget ({{ currencyCode }})</h3>
          </div>
          <div>
            <!--<vs-row class="mb-5">
              <span
                ><b style="font-size: 1.3rem"
                  >{{ budgetMonth.cost }} / {{ budgetMonth.budget }} DKK</b
                ></span
              >
              <vs-progress
                :percent="
                  (budgetMonth.cost / budgetMonth.budget) * 100
                "
                height="10"
                color="primary"
                >primary</vs-progress
              >
            </vs-row>-->
            <vs-row class="mb-2">
              <vs-col vs-w="6" class="mb-1">
                <vs-row class="mb-1">
                  <vs-col v-if="!budgetSetMode" vs-w="6"><span>Budget:</span></vs-col>
                  <vs-col v-if="!budgetSetMode" vs-w="6"
                    ><span
                      ><b>{{ budgetThisMonth.budget }}</b>
                    </span>
                  </vs-col>
                  <vs-input-number
                    v-if="budgetSetMode"
                    label="Budget"
                    min="0"
                    step="500"
                    size="medium"
                    v-model="budgetIncrementer"
                  />
                </vs-row>
                <vs-row class="mb-1">
                  <vs-col vs-w="6"><span>Spent:</span></vs-col>
                  <vs-col vs-w="6" class="align-right justify-right"
                    ><span
                      ><b>{{ budgetThisMonth.cost }}</b></span
                    ></vs-col
                  >
                </vs-row>
                <vs-row class="mb-1">
                  <vs-col vs-w="6"><span>Leftover:</span></vs-col>
                  <vs-col vs-w="6" class="align-right justify-right"
                    ><span
                      v-bind:class="{
                        colorOverBudget: isOverBudget,
                        colorUnderBudget: !isOverBudget,
                      }"
                      ><b>{{ budgetThisMonth.budget - budgetThisMonth.cost }}</b></span
                    ></vs-col
                  >
                </vs-row>
              </vs-col>
              <!--<vs-col v-if="!budgetSetMode" vs-w="6">
                <vs-row vs-justify="flex-end" class="mb-1"
                  ><img
                    src="@/assets/images/fb.png"
                    width="15"
                    height="15"
                    class="rounded-full block"
                  />
                  <span class="ml-2"> 3.600 {{ currencyCode }}</span></vs-row
                >
                <vs-row vs-justify="flex-end" class="mb-1"
                  ><img
                    src="@/assets/images/ig.png"
                    width="15"
                    height="15"
                    class="rounded-full block"
                  />
                  <span class="ml-2"> 4.900 {{ currencyCode }}</span></vs-row
                >
              </vs-col>-->

              <vs-col v-if="!budgetSetMode" vs-w="6">
                <vs-row v-for="(t, index) of smcPriceClasses" :key="index" vs-justify="flex-end" class="mb-1">
                  <span style="line-height: 22px" class="mr-3"> {{ t.cost }}</span
                  ><img
                    :src="require(`@/assets/images/smc/${t.img}.png`)"
                    width="22"
                    height="22"
                    class="rounded-full block"
                  />
                </vs-row>
              </vs-col>
            </vs-row>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                @click="toggleBudgetSetMode"
                :color="budgetSetMode ? 'primary' : 'grey'"
                icon="edit"
              ></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="4" class="pl-5">
        <vs-card>
          <div slot="header">
            <h3>Comments</h3>
          </div>
          <div>
            <tiptap
              :isEditing="isEditingComment"
              v-model="currentComment"
              defaultText="Ingen kommentar denne måned"
              v-on:onUpdate="newComment => (editComment = newComment)"
              ref="tiptap"
            />
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                v-if="!isEditingComment"
                color="grey"
                icon="edit"
                @click="handleEditComment"
              ></vs-button>
              <vs-button
                v-if="isEditingComment"
                color="primary"
                icon="save"
                class="mr-3"
                @click="handleSaveComment"
              ></vs-button>
              <vs-button
                v-if="isEditingComment"
                color="close"
                icon="close"
                @click="handleIgnoreComment"
              ></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row class="calendar-wrapper mt-5">
      <vs-col vs-w="5" vs-justify="flex-start" vs-type="flex" vs-align="center">
        <div class="flex items-center mr-4">
          <div class="h-3 w-3 inline-block rounded-full mr-2 bg-success"></div>
          <span>Activities</span>
        </div>
        <div class="flex items-center mr-4">
          <div class="h-3 w-3 inline-block rounded-full mr-2 bg-warning"></div>
          <span>Social Media Content</span>
        </div>
        <div class="flex items-center mr-4">
          <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
          <span>Paid Media</span>
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="flex-end" vs-w="7">
        <vs-button
          v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.activationplan.create.activity')"
          @click.native="$refs.popupAddEvent.show(null)"
          color="primary"
          type="filled"
          icon="add"
        >
          Activity
        </vs-button>
        <vs-button
          v-if="$AuthService.hasPermissionForActiveVenue('p.vp.activationplan.create.social')"
          @click.native="$refs.popupAddSoMe.show(null, true)"
          color="primary"
          type="filled"
          icon="add"
          class="ml-5"
        >
          Social
        </vs-button>
        <vs-button
          v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.activationplan.create.paidmedia')"
          @click.native="$refs.popupAddSoMe.show(null, false)"
          color="primary"
          type="filled"
          icon="add"
          class="ml-5"
        >
          Paid Media
        </vs-button>
        <vs-button
          v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.activationplan.insertFromTemplate')"
          @click.native="$refs.popupAddFromTemplate.show(calendarYear)"
          color="primary"
          type="border"
          icon="add"
          class="ml-5"
        >
          Templates
        </vs-button>
      </vs-col>

      <vs-col vs-w="12" class="calendar-wrapper">
        <FullCalendar :options="{ ...calendarOptions, events: mapEvents }" ref="fullCalendar" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import rrulePlugin from "@fullcalendar/rrule";
import interactionPlugin from "@fullcalendar/interaction";
import PopupSelectEventType from "./Popups/PopupSelectEventType.vue";
import PopupAddEvent from "./Popups/PopupAddEvent.vue";
import PopupAddCampaign from "./Popups/PopupAddCampaign.vue";
import PopupAddFromTemplate from "./Popups/PopupAddFromTemplate.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import { RRule, RRuleSet, rrulestr } from "rrule";
import "tippy.js/dist/tippy.css";
import tippy from "tippy.js";
import Tiptap from "@/layouts/components/tiptap/TipTap.vue";
import PopupAddSoMe from "./Popups/PopupAddSoMe.vue";

export default {
  components: {
    PopupAddEvent,
    PopupAddSoMe,
    PopupAddCampaign,
    PopupAddFromTemplate,
    PopupSelectEventType,
    FullCalendar,
    Tiptap,
  },
  data() {
    return {
      smcTypes: ["Facebook", "Instagram", "Youtube", "App", "SMS", "Newsletter", "Other"],
      currencyMap: {
        Danmark: "DKK",
        Finland: "EUR",
        Norge: "NOK",
        England: "GBP",
      },
      budgetIncrementer: 0,
      budgetSetMode: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, rrulePlugin],
        timeZome: "UTC",
        aspectRatio: 2,
        initialView: "dayGridMonth",
        headerToolbar: {
          left: "",
          center: "",
          right: "",
        },
        weekends: true,
        firstDay: 1,
        selectable: true,
        dateClick: this.handleDateClick,
        select: this.handleSelect,
        displayEventTime: false, // for ikke at vise tid
        timeFormat: "H:(mm)",
        eventTimeFormat: {
          hour: "2-digit",
          minute: "2-digit",
          meridiem: false,
          hour12: false,
        },
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        eventContent: function (info) {
          if (info.event.extendedProps.type != 0) {
            const imageStr = require(`@/assets/images/smc/${info.event.extendedProps.meta.platform}.png`);
            return {
              html: `
                  <img
                    src="${imageStr}"
                    width="18"
                    height="18"
                    class="rounded-full m-1"
                    style="vertical-align: middle"
                  />

                  <span>${info.event.title}</span>
                  `,
            };
          }
          return info.event.extendedProps.title;
        },
        eventDidMount: function (info) {
          // The popup to show on hover event
          tippy(info.el, {
            content: info.event.extendedProps.popupContent,
            zIndex: 99999,
            allowHTML: true,
          });
        },
      },
      addNewEventPrompt: false,
      calendarApi: null,
      calendarTitle: "",
      calendarMonth: "",
      editComment: "",
      isEditingComment: false,
      calendarMonthNumber: 0,
      calendarYear: "",
      list: {
        Facebook: [
          { value: 0, text: "Feed" },
          { value: 1, text: "Story" },
          { value: 2, text: "Event" },
          { value: 3, text: "Competition" },
        ],
        Instagram: [
          { value: 0, text: "Feed" },
          { value: 1, text: "IGTV" },
          { value: 2, text: "Story" },
          { value: 3, text: "Competition" },
        ],
        Youtube: [{ value: 0, text: "Video" }],
        App: [{ value: 0, text: "Message" }],
        SMS: [{ value: 0, text: "Message" }],

        Newsletter: [{ value: 0, text: "Link" }],
        Other: [{ value: 0, text: "Other" }],
      },
    };
  },
  async mounted() {
    this.$vs.loading();
    //await this.$store.dispatch("venues/ensureUserVenues"); //ensureUserVenues
    await Promise.all([
      this.$store.dispatch("activationPlan/getEvents", this.activeVenue.venueId),
      this.$store.dispatch("activationPlan/getComments", this.activeVenue.venueId),
      this.$store.dispatch("activationPlan/getBudgets", this.activeVenue.venueId),
      this.$store.dispatch("activationPlan/getCampaigns", this.activeVenue.venueId),
    ]);
    this.calendarApi = this.$refs.fullCalendar.getApi();
    this.updateCalendarInfo();
    this.$vs.loading.close();
  },
  methods: {
    handleDateClick(param1, param2) {
      //console.log("click", param1, param2);
    },
    handleSelect(dates) {
      this.$refs.popupSelectEventType.show(dates);
    },
    onSelectedEventType(type, dates) {
      if (type === 0) {
        this.$refs.popupAddEvent.show(dates);
      } else {
        this.$refs.popupAddSoMe.show(dates, type === 1);
      }
      console.log("SELECTED", type, dates);
    },
    handleEditComment() {
      this.$refs.tiptap.setEditable(true);
      this.isEditingComment = true;
      if (this.currentComment) {
        this.editComment = this.currentComment.comment;
      } else {
        this.editComment = "";
      }
    },
    async handleSaveComment() {
      this.$vs.loading();
      this.$refs.tiptap.setEditable(false);

      const newComment = {
        month: this.calendarMonthNumber,
        year: this.calendarYear,
        comment: this.editComment,
        venueId: this.activeVenue.venueId,
      };

      if (this.currentComment == null) {
        await this.$store.dispatch("activationPlan/addComment", {
          comment: newComment,
          venueId: this.activeVenue.venueId,
        });
      } else {
        newComment.id = this.currentComment.commentId;

        await this.$store.dispatch("activationPlan/updateComment", {
          comment: newComment,
          venueId: this.activeVenue.venueId,
        });
      }
      this.isEditingComment = false;

      this.$vs.notify({
        color: "success",
        title: "Comment changed",
        text: `The comment for ${this.calendarMonth} was changed`,
      });
      this.$vs.loading.close();
    },
    handleIgnoreComment() {
      this.$refs.tiptap.setEditable(false);
      this.isEditingComment = false;
    },
    async toggleBudgetSetMode() {
      this.budgetSetMode = !this.budgetSetMode;

      if (this.budgetSetMode) {
        this.budgetIncrementer = this.budgetThisMonth.budget;
      } else {
        this.$vs.loading();

        const dto = {
          venueId: this.activeVenue.venueId,
          year: this.calendarYear,
          month: this.calendarMonthNumber,
          budget: parseInt(this.budgetIncrementer),
        };
        if (this.budgetThisMonth.budget !== dto.budget) {
          await this.$store.dispatch("activationPlan/setBudget", dto);
        }

        setTimeout(() => this.$vs.loading.close(), 20);
        this.$vs.notify({
          color: "success",
          title: "Budgets updated",
          text: `Budget for ${this.calendarMonth} was updated`,
        });
      }
    },
    getDateFromWeek(week, year) {
      return moment().day("Monday").year(year).isoWeek(week).toDate();
    },
    handleEventClick(data) {
      const eventId = data.event.id;
      const eventData = this.event(eventId);
      console.log("Clicked event", eventData);
      if (eventData.type == 0) {
        this.$refs.popupAddEvent.showWith(eventData, data.event.start);
      } else {
        this.$refs.popupAddSoMe.showWith(eventData, data.event.start);
      }
    },
    handlePrevMonth() {
      if (this.isEditingComment || this.budgetSetMode) {
        this.$vs.notify({
          color: "danger",
          title: "Warning",
          text: `Cannot change calendar month while editing comment or budgets`,
        });
        return false;
      }

      this.calendarApi.prev();
      this.updateCalendarInfo();
    },
    handleNextMonth() {
      if (this.isEditingComment || this.budgetSetMode) {
        this.$vs.notify({
          color: "danger",
          title: "Warning",
          text: `Cannot change calendar month while editing comment or budgets`,
        });
        return false;
      }

      this.calendarApi.next();
      this.updateCalendarInfo();
    },
    handleClickCampaign(campaign) {
      // If it is a HQ campaign but the user is not HQ
      if (campaign.isHQ && !this.isHQ) {
        return;
      }

      this.$refs.popupAddCampaign.showWith(campaign, this.calendarYear, this.calendarMonthNumber);
    },

    async updateCalendarInfo() {
      this.calendarTitle = moment(this.calendarApi.getDate()).format("MMMM YYYY");
      this.calendarMonth = moment(this.calendarApi.getDate()).format("MMMM");
      this.calendarMonthNumber = this.calendarApi.getDate().getMonth() + 1;
      this.calendarYear = this.calendarApi.getDate().getFullYear();
    },
    eventTypeToColor(type) {
      switch (type) {
        case 0:
          return "#29c76f";
        case 1:
          return "#FF9F43";
        case 2:
          return "#7167e8";
        default:
          return "#aa0000";
      }
    },
    generateEventPopup(e) {
      let result = `<strong><center>${e.title}</center></strong>`;
      if (e.description != "") {
        result += "<br>" + e.description;
      }

      if (e.type == 1 || e.type == 2) {
        result += `<br><br>${e.meta.platform} ${this.getSMCPlatformType(e)}`;
      }
      if (e.type == 2) {
        result += ` - ${e.meta.price} ${this.currencyCode}`;
      }

      if (e.meta && e.meta.responsibleName) {
        result += `<br><strong>Responsible: </strong>${e.meta.responsibleName.split(" (")[0]}`;
      }

      return result;
    },

    getSMCPlatformType(event) {
      if (!event.meta.platform || !event.meta.type) {
        return "";
      }

      const res = this.list[event.meta.platform];
      if (!res) {
        // If the platform is not valid, treat it as "other" type
        return "Other";
      }
      const found = res.find(e => e.value == event.meta.type);
      if (!found || !found.text) return "";
      return found.text;
    },
  },
  computed: {
    ...mapGetters({
      isHQ: "users/isHQ",
      event: "activationPlan/event",
      events: "activationPlan/events",
      comment: "activationPlan/comment",
      budget: "activationPlan/budget",
      campaigns: "activationPlan/campaigns",
      activeVenue: "venues/activeVenue",
    }),
    currencyCode() {
      return this.currencyMap[this.activeVenue.country];
    },
    mapEvents() {
      return this.events.map(e => {
        console.log("EVENT", e);
        const nE = {
          ...e,
          id: e.activationPlanEventId,
          popupContent: this.generateEventPopup(e),
          color: this.eventTypeToColor(e.type),
          allDay: true,
        };

        const endDate = new Date(e.endDateUtcTicks);
        endDate.setDate(endDate.getDate() + 1); // Add +1 because endDate is EXCLUSIVE when allDay=true
        return e.isRecurring
          ? {
              ...nE,
              rrule: e.rRule,
              exdate: rrulestr(e.rRule, { forceset: true })
                .exdates()
                .map(e => moment(e).format("YYYYMMDD")),
            }
          : {
              ...nE,
              start: new Date(e.startDateUtcTicks),
              end: endDate,
            };
      });
    },
    smcThisMonth() {
      const thisMonth = moment(`${this.calendarYear}-${this.calendarMonthNumber}-01`);
      return this.events.filter(
        e => moment(e.startDateUtcTicks).isSame(thisMonth, "month") && e.type === 2, // It is now Paid Media
      );
    },
    smcPriceClasses() {
      const filteredEvents = this.smcThisMonth;
      const smcCost = {
        Facebook: { cost: 0, img: "Facebook", show: true },
        Instagram: { cost: 0, img: "Instagram", show: true },
        Youtube: { cost: 0, img: "Youtube", show: true },
        App: { cost: 0, img: "App", show: true },
        SMS: { cost: 0, img: "SMS", show: true },
        Newsletter: { cost: 0, img: "Newsletter", show: true },
        Other: { cost: 0, img: "Other", show: true },
      };
      filteredEvents.forEach(e => {
        smcCost[e.meta.platform].cost += parseInt(e.meta.price);
      });
      return smcCost;
    },
    budgetThisMonth() {
      const filteredEvents = this.smcThisMonth;
      const b = this.budget(this.calendarYear, this.calendarMonthNumber);
      return {
        cost: _.sumBy(filteredEvents, e => parseInt(e.meta.price)),
        budget: b ? b.budget : 0,
      };
    },

    isOverBudget() {
      return this.budgetThisMonth.cost > this.budgetThisMonth.budget;
    },

    currentComment() {
      const comment = this.comment(this.calendarYear, this.calendarMonthNumber);
      return comment;
    },
    currentCampaigns() {
      const campaigns = this.campaigns(this.calendarYear, this.calendarMonthNumber);
      campaigns.sort((c1, c2) => (c1.starred && !c2.starred ? -1 : 1));
      return campaigns;
    },
  },
};
</script>

<style lang="scss">
.campaign-button .vs-chip--text {
  font-weight: bold;
}
.fc-content,
.fc-daygrid-day-events {
  cursor: pointer;
}
.colorOverBudget {
  color: red;
}

.colorUnderBudget {
  color: green;
}
.vs-textarea {
  font-size: 0.9rem;
  height: 198px; // Fix for Vuesax
}
.calendar-wrapper {
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px;
}

.campaign-item {
  cursor: pointer;
}
</style>